<template lang="html">
  <section>
    <div class="p-4">
      <div class="columns is-centered is-vcentered">
        <div class="column is-9">
          <!-- Step -->
          <div class="box">
            <div class="columns is-vcentered is-centered">
              <div class="column is-5">
                <component :is="leftComponent" :images="images" :step="step" />
              </div>
              <!-- Step number -->
              <div class="column has-text-centered is-1">
                <div class="p-3">
                  <a v-if="owner && editing" @click="isEditStepModalActive = true">
                    <b-icon type="is-success" icon="pencil"></b-icon>
                  </a>
                </div>
                <div class="field">
                  <b-tag type="is-primary" size="is-large" rounded>{{ index + 1 }}</b-tag>
                </div>
              </div>

              <div class="column is-5 has-text-justified">
                <component :is="rightComponent" :images="images" :step="step" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modals and Components -->
    <b-modal
      :active.sync="isEditStepModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <edit-step
        @imagesUpdated="images = $event"
        @updateStep="updateStep"
        @deleteStep="deleteStep"
        @stepUpdated="stepUpdated"
        :step="step"
      />
    </b-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import EditStep from '@/components/concerns/Steps/EditStep'
import Images from '@/components/concerns/Steps/Images'
import Description from '@/components/concerns/Steps/Description'
import ImageManagement from '@/components/concerns/Images/ImageManagement'
export default {
  props: ['index', 'step', 'editing'],
  data () {
    return {
      isEditStepModalActive: false,
      images: []
    }
  },
  created () {
    this.fetchImages()
  },
  methods: {
    deleteStep () {
      this.$buefy.dialog.confirm({
        message: 'Delete this step?',
        onConfirm: () => this.$emit('deleteStep', this.step.id)
      })
    },
    updateStep (values) {
      this.$emit('updateStep', { id: this.step.id, payload: values })
    },
    stepUpdated (values) {
      this.$emit('stepUpdated', values)
    },
    fetchImages () {
      this.$store
        .dispatch('images/index', {
          imageableType: 'step',
          imageableId: this.step.id
        })
        .then((resp) => {
          this.images = resp.data.data
        })
        .catch((error) => {
          console.log('error')
          console.log(error.response)
        })
    }
  },
  components: {
    ImageManagement,
    EditStep,
    Description,
    Images
  },
  computed: {
    owner () {
      return this.isOwner(this.step.attributes.user_id)
    },
    ...mapGetters({
      isOwner: 'isOwner'
    }),
    even () {
      return this.index % 2 === 0
    },
    leftComponent () {
      return this.even ? 'Description' : 'Images'
    },
    rightComponent () {
      return this.even ? 'Images' : 'Description'
    }
  }
}
</script>

<style lang="css" scoped></style>
